var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":`${_vm.$route.query.title} Comments`,"is_createable":true,"fields":_vm.fields,"response":_vm.data},on:{"edit_click":_vm.editClick,"create":_vm.createComment,"delete":_vm.deleteComment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }